import(/* webpackMode: "eager" */ "/app/apps/lab-app/app/error.tsx")